var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79487 22.5696C2.2454 22.5696 1.76462 22.3609 1.35252 21.9436C0.940424 21.5264 0.734375 21.0395 0.734375 20.4831V2.40026C0.734375 1.84387 0.940424 1.35702 1.35252 0.939726C1.76462 0.52243 2.2454 0.313782 2.79487 0.313782H26.1471C26.6966 0.313782 27.1774 0.52243 27.5895 0.939726C28.0016 1.35702 28.2076 1.84387 28.2076 2.40026V20.4831C28.2076 21.0395 28.0016 21.5264 27.5895 21.9436C27.1774 22.3609 26.6966 22.5696 26.1471 22.5696H2.79487ZM14.471 12.0676L2.79487 4.31287V20.4831H26.1471V4.31287L14.471 12.0676ZM14.471 9.98115L26.0097 2.40026H2.96657L14.471 9.98115ZM2.79487 4.31287V2.40026V4.31287V20.4831V4.31287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.31da27392f6aa0f7db28669b76f8345f.svg";
export { ForwardRef as ReactComponent };